import React, { useRef } from 'react'
import ReactDOM from 'react-dom'
import s from './modal.module.css'
import Btn from '../buttons/buttons'
import { IcoClose } from '../../svg/close'
import useEscapeKey from '../../hooks/useEscapeKey'
import useOutsideClick from '../../hooks/useOutsideClick'

const Modal = props => {
  
  // Llama al hook useEscapeKey boton ESC
  useEscapeKey(props.onClose)

  const ref = useRef(null)

  // Llama al hook useOutsideClick click en el overlay
  useOutsideClick(props.onClose, ref)

  return ReactDOM.createPortal(
    <div className={`${s.modal}`}>
      <div className={`bg-white ${s.modalContent} ${s[props.size]}`} ref={ref}>
        {props.onClose && (
          <button
            className={`${s.modalCloseButton}`}
            type="button"
            onClick={props.onClose}
          >
            <IcoClose fill={props.icoCloseColor} />
          </button>
        )}
        <div className={`${s.modalPaddingDefault} ${s.modalOverflow}`}>
          {props.children}
          {props.addBottomCLose && (
            <div className="center">
              <Btn
                label={props.addBottomCLoseLabel}
                size="medium"
                onClick={props.onClose}
                type="button"
              />
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  )
}

Modal.defaultProps = {
  addBottomCLose: false, // Botón inferior para cerrar modal
  addBottomCLoseLabel: 'Cerrar', // Label del boton inferior para cerrar modal
  onClose: '', // callBack cerrar modal
  icoCloseColor: '#45494E', // Color del icono
  className: '', // Clase CSS
}

export default Modal
